import { Add } from '@mui/icons-material'
import { useQuery } from '@tanstack/react-query'
import { ISelectItem } from 'app/components/filter/defaultFilter'
import Search from 'app/components/search/Search'
import { PageContentContainer } from 'app/components/styles'
import TableHeader from 'app/components/table/tableHeader/TableHeader'
import { ITableHeadCell, Order } from 'core/models/table'
import { fecthCollaborator } from 'core/querryes/collaborator/collaboratorQuerry'
import theme from 'core/theme/theme'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { IconButton, Tooltip } from '@mui/material'
import DataTable from 'app/components/table/table/table'
import DataTablePagination from 'app/components/table/pagination/pagination'
import DefaultMenu, { IMenuItemProps } from 'app/components/menu/DefaultMenu'
import MoreHorizRounded from '@mui/icons-material/MoreHorizRounded'
import CollaboratorDetailsModal from 'app/components/modals/detailsModal/CollaboratorDetailsModal'
import { ContentBody } from 'app/styles'
import EditCollaboratorModal from '../editers/editCollaborator'
import { removeNonNumeric } from 'core/utils/globalFunctions'
import NewDefaultFilter from 'app/components/filter/newDefaultFilter'

const head: ITableHeadCell[] = [
    { name: 'name', label: 'Nome', align: 'left' },
    { name: 'rg', label: 'RG', align: 'left' },
    { name: 'cpforcnpj', label: 'CPF', align: 'left' },
    { name: 'createdAt', label: 'Criado em', align: 'left' },
    { name: 'actions2', label: 'Opções', align: 'left' }
]

const filterItems: ISelectItem[] = [
    { name: 'Nome', value: 'name', type: 'texto' },
    { name: 'CPF', value: 'cpforcnpj', type: 'texto' }
]

function Collaborator() {
    const navigate = useNavigate()
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(0)
    const [order, setOrder] = useState<Order>('asc')
    const [orderBy, setOrderBy] = useState('name')
    const [filterModal, setFilterModal] = useState(false)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const [idCollaborator, setIdCollaborator] = useState<string | undefined>()
    const [details, setDetails] = useState(false)
    const [deleteDialog, setDeleteDialog] = useState(false)
    const [isOpen, setIsOpen] = useState(false)

    const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const handleAccessRowById = (id: string) => {
        setIdCollaborator(id)
    }

    const menuItems: IMenuItemProps[] = [
        {
            function: () => {
                setDetails(true)
                handleAccessRowById(idCollaborator || '')
                handleCloseMenu()
            },
            label: 'Detalhes do colaborador'
        },
        {
            function: () => {
                setIsOpen(true)
                handleCloseMenu()
            },
            label: 'Editar colaborador'
        }
    ]

    const [searchParams, setSearchParams] = useSearchParams()
    const name = searchParams.get('name') || ''
    const cpforcnpj = searchParams.get('cpforcnpj') || ''

    const { data, isLoading, isSuccess, refetch } = useQuery({
        queryKey: [
            'clients',
            page,
            rowsPerPage,
            orderBy,
            order,
            name,
            cpforcnpj,
            ],
            queryFn: () =>
                fecthCollaborator(
                    page,
                    rowsPerPage,
                    orderBy,
                    order,
                    name,
                    cpforcnpj,
                ),
    })

    const handleCpfCnpjChange = (value: string | undefined) => {
        const newParams = new URLSearchParams(searchParams)
        if (value) {
            newParams.set('cpforcnpj', removeNonNumeric(value) ?? '')
        } else {
            newParams.delete('cpforcnpj')
        }
        setSearchParams(newParams)
    }

    useEffect(() => {
        if (isSuccess && data) {
            setCount(data.totalElements)
        }
    }, [isSuccess, data])

    const selectedCollaborator = data?.content.find(
        (collaborator: any) => collaborator.id === idCollaborator
    )

    return (
        <PageContentContainer>
            <TableHeader
                filterBtn
                filterBtnAction={() => setFilterModal(true)}
                mainActionFunction={() => navigate('/registrarColaborador')}
                mainActionLabel="Cadastrar colaborador"
                mainIcon={<Add sx={{ color: theme.COLORS.YELLOW2 }} />}
                extraComponents={
                    <Search
                        querry={cpforcnpj}
                        onChange={handleCpfCnpjChange}
                        type="number"
                        searchPlaceHolder="Cpf ou cnpj do colaborador..."
                        querrySearching={isLoading}
                    />
                }
            />
            <ContentBody>
                <DataTable
                    head={head}
                    data={data?.content}
                    order={order}
                    orderBy={orderBy}
                    setOrder={setOrder}
                    setOrderBy={setOrderBy}
                    isLoading={isLoading}
                    accessRowById={handleAccessRowById}
                    menu={
                        <Tooltip title="Opções">
                            <IconButton onClick={handleClickMenu}>
                                <MoreHorizRounded />
                            </IconButton>
                        </Tooltip>
                    }
                />
                <DefaultMenu
                    anchor={anchorEl}
                    menuItems={menuItems}
                    onClose={handleCloseMenu}
                    status={open}
                />
                {selectedCollaborator && details && (
                    <CollaboratorDetailsModal
                        collaborator={selectedCollaborator}
                        isOpen={details}
                        onClose={() => setDetails(false)}
                        onOpen={() => setDetails(true)}
                    />
                )}
                <DataTablePagination
                    setPage={setPage}
                    page={page}
                    setRowsPerPage={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    count={count}
                />
                <NewDefaultFilter
                    isOpen={filterModal}
                    items={filterItems}
                    onClose={() => setFilterModal(false)}
                    onOpen={() => setFilterModal(true)}
                    title="Filtrar Colaboradores"
                    changePage={setPage}
                />
                {selectedCollaborator && isOpen && (
                    <EditCollaboratorModal
                        isOpen={isOpen}
                        onOpen={() => setIsOpen(true)}
                        onClose={() => setIsOpen(false)}
                        setIsOpen={setIsOpen}
                        collaborator={selectedCollaborator}
                        refetch={refetch}
                    />
                )}
            </ContentBody>
        </PageContentContainer>
    )
}

export default Collaborator
